import { render, staticRenderFns } from "./AppConfigurationPage.vue?vue&type=template&id=5c4e7757&"
import script from "./AppConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./AppConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4e7757')) {
      api.createRecord('5c4e7757', component.options)
    } else {
      api.reload('5c4e7757', component.options)
    }
    module.hot.accept("./AppConfigurationPage.vue?vue&type=template&id=5c4e7757&", function () {
      api.rerender('5c4e7757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/AppConfigurationPage.vue"
export default component.exports